import { render, staticRenderFns } from "./sendSMSRegister.vue?vue&type=template&id=65b43dda&scoped=true&"
import script from "./sendSMSRegister.vue?vue&type=script&lang=ts&"
export * from "./sendSMSRegister.vue?vue&type=script&lang=ts&"
import style0 from "./sendSMSRegister.vue?vue&type=style&index=0&id=65b43dda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b43dda",
  null
  
)

export default component.exports